import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ImageType } from '../../../models/image.model';
import { trigger, transition, style, animate } from '@angular/animations';
import { slideToggle } from '../../../helpers/slidetoggle';
@Component({
  selector: 'lib-image-section',
  templateUrl: './image-section.component.html',
  styleUrls: ['./image-section.component.scss'],
  animations: [slideToggle],
  standalone: false,
})
export class ImageSectionComponent {
  @Input() image: string | undefined = undefined;
  @Input() title: string | undefined = undefined;
  @Input() index: number = -1;
  @Input() imageType!: ImageType;
  @Input() editEnabled = false;
  @Input() permission = true;
  @Input() inputId = '';
  @Input() imageId :string = '';
  @Input() imageSectionExpanded: boolean = true;
  @Output() imageClick = new EventEmitter<number>();
  @Output() fileChange = new EventEmitter<{
    file: File;
    type: ImageType;
    imageId: number;
  }>();

  onImageClick() {
    this.imageClick.emit(this.index);
  }

  onFileSelected(event: any) {
    const file = event.target.files.item(0);
    if (file) {
      this.fileChange.emit({
        file,
        type: this.imageType,
        imageId: this.editEnabled ? this.index : -1,
      });
    }
  }
}
